import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateGamePartnerSwitchActive = {
  gamePartnerSwitchActive: { data: null, loading: false, error: null },
};

export const gamePartnerSwitchActive = createAsyncThunk('user/gamePartnerSwitchActive', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .post(`/game/partner/switch-active`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGamePartnerSwitchActive = {
  [gamePartnerSwitchActive.pending]: (state) => {
    state.gamePartnerSwitchActive.loading = true;
  },
  [gamePartnerSwitchActive.fulfilled]: (state, action) => {
    state.gamePartnerSwitchActive.loading = false;
    state.gamePartnerSwitchActive.data = action.payload;
    state.gamePartnerSwitchActive.error = null;
  },
  [gamePartnerSwitchActive.rejected]: (state, action) => {
    state.gamePartnerSwitchActive.loading = false;
    state.gamePartnerSwitchActive.error = action.payload;
  },
};
